import { AccommodationCategory } from 'proto/Accommodation/AccommodationCategory';
import { Attribute } from 'proto/Accommodation/Attributes';
import { Exterior } from 'proto/Offer/Accommodation/Exterior';
import { PoolType } from 'proto/Offer/Accommodation/PoolType';
import { ViewType } from 'proto/Offer/Accommodation/ViewType';
import { MealType } from 'proto/Offer/MealType';
import { RoomType } from 'proto/Offer/Room/RoomType';
import { RoomClass } from 'proto/Offer/RoomClass';

export type AirportValue<Type extends string = string> = Set<Type>;

export interface RangeValue<Type> {
    min: Type | null;
    max: Type | null;
}

export interface FlightFilter {
    departureFlightTime?: RangeValue<number>;
    returnFlightTime?: RangeValue<number>;
    directFlight: boolean;
    withNoBag: boolean;
    airlineList: Set<string>;
    hideMixFlights: boolean;
    destinationAirportList: AirportValue;
}
export interface TransferFilter {
    hotelTransfer: boolean;
    privateTransfer: boolean;
    railAndFly: boolean;
}

export enum HotelCategoryFilter {
    Five = 5,
    Four = 4,
    Three = 3,
    Two = 2,
    One = 1,
}

export interface AccommodationFilter {
    mealTypeList: Set<MealType>;
    roomTypeList: Set<RoomType>;
    roomClassList: Set<RoomClass>;
    viewTypeList: Set<ViewType>;
    poolTypeList: Set<PoolType>;
    exteriorList: Set<Exterior>;
    hotelCategoryList: Set<HotelCategoryFilter>;
    rating?: number;
    accommodationCategoryList: Set<AccommodationCategory>;
    attributesList: Set<Attribute>;
    withHygieneFacts: boolean;
}

export enum CancellationType {
    Free = 'free',
    Cost = 'cost',
    Free24Hour = 'free24Hour',
}

export interface SpecialFilter {
    cancellation?: CancellationType;
    rebookable: boolean;
    reservable: boolean;
    lowDeposit: boolean;
    promoDiscount: boolean;
}

export enum TourOperatorCategory { //replace with proto enum
    Classic = 'K',
    Dynamic = 'X',
}

export enum PaymentTypeFilter {
    CreditCardMastercard = 'creditcard_mc',
    CreditCardVisa = 'creditcard_vi',
    CreditCardAmericanExpress = 'creditcard_ax',
    BankTransfer = 'banktransfer',
    DirectDebit = 'directdebit',
    PayPal = 'paypal',
    SofortUeberweisung = 'sofortueberweisung',
}

export interface Filter {
    budget?: RangeValue<number>;
    tourOperatorList: Set<string>;
    tourOperatorCategoryList: Set<TourOperatorCategory>;
    flight: FlightFilter;
    transfer: TransferFilter;
    paymentTypeList: Set<PaymentTypeFilter>;
    accommodation: AccommodationFilter;
    special: SpecialFilter;
}
